import { render } from "./MenuRouterLink.vue?vue&type=template&id=a7f838b8"
import script from "./MenuRouterLink.vue?vue&type=script&lang=js"
export * from "./MenuRouterLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__